import { Platform } from "react-native";
import Constants from "expo-constants";

/**
 * Gets the navigation prefix based on platform and environment
 * @returns The appropriate navigation prefix URL
 */
export const getNavigationPrefix = (): string => {
  let navigationPrefix =
    process.env.EXPO_PUBLIC_NAVIGATION_PREFIX ||
    Constants.expoConfig?.extra?.NAVIGATION_PREFIX ||
    "https://openhouse.brivity.com";

  if (Platform.OS === "web" && process.env.NODE_ENV === "development") {
    navigationPrefix = "https://openhouse.staging.brivity.com";
  }

  return navigationPrefix;
};

/**
 * Gets the API URL based on platform and environment
 * @returns The appropriate API URL
 */
export const getApiUrl = (): string => {
  let apiUrl = "https://open-house.brivity.com";

  apiUrl =
    process.env.NODE_ENV === "development"
      ? "https://open-house.staging.brivity.com"
      : "https://open-house.brivity.com";

  return apiUrl;
};

/**
 * Gets the middleware API URL based on platform and environment
 * @returns The appropriate middleware API URL
 */
export const getMiddlewareApiUrl = (): string => {
  let apiUrl = "https://brivity-middleware.brivity.com";

  apiUrl =
    process.env.NODE_ENV === "development"
      ? "https://brivity-middleware.staging.brivity.com"
      : "https://brivity-middleware.brivity.com";

  return apiUrl;
};
